'use client'

import { DropdownMenuItem, type NavbarItemVariant, NavbarLink } from '@portal/taonga-ui'

import { css, cx } from '@news/styled-system/css'
import { useI18n } from '@/shared/providers'

type NewsButtonProps = {
    variant?: NavbarItemVariant
    newsPostBell: React.ReactNode
}

export function NewsLink({ variant = 'default', newsPostBell }: NewsButtonProps) {
    const { i18n } = useI18n()

    if (variant === 'default') {
        return (
            <NavbarLink href="/" target="_self" className={css({ display: { base: 'none', xl: 'flex' } })}>
                {i18n.BUTTON_NEWS}&nbsp;
                {newsPostBell}
            </NavbarLink>
        )
    }

    return (
        <DropdownMenuItem href="/">
            <i className={cx('fa-light fa-newspaper', css({ color: 'success' }))} />
            &nbsp;{i18n.BUTTON_NEWS}&nbsp;
            {newsPostBell}
        </DropdownMenuItem>
    )
}
